import { Injectable } from '@angular/core';
import { TransactionalService } from '../transactional.service';
import { Observable } from 'rxjs';
import { IResponse } from '../../../models/dtos/response.interface';
import { HttpParams } from '@angular/common/http';
import { ISubscriptionType } from '../../../models/dtos/get/subscription-type.interface';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionTypeService {

  constructor(private _transactionalService: TransactionalService) { }

  public get(userId: string): Observable<IResponse<ISubscriptionType[]>> {

    let params = new HttpParams()
      .set('userId', userId);

    return this._transactionalService.get<IResponse<ISubscriptionType[]>>(
      `get-subscription-types?${params.toString()}`
    );
  }
}